export const QuestionStatus = {
  EDIT: 1,
  SUBMIT_1: 2,
  DECLINE_1: 3,
  ACCEPT: 4,
  DELETE: 5,
  SUBMIT_2: 6,
  DECLINE_2: 7,
};

export const QuestionStatusText = {
  [QuestionStatus.EDIT]: '編輯中',
  [QuestionStatus.SUBMIT_1]: '待初審',
  [QuestionStatus.DECLINE_1]: '初審不通過',
  [QuestionStatus.ACCEPT]: '已通過',
  [QuestionStatus.DELETE]: '已刪除',
  [QuestionStatus.SUBMIT_2]: '待複審',
  [QuestionStatus.DECLINE_2]: '複審不通過',
};

export const ExamSaleType = {
  4: '無詳解',
  3: '無影片詳解',
  2: '無文字詳解',
  1: '完整詳解',
};

export const ProductType = {
  questionBank: '題庫',
  hangout: '課程',
};

export const ProductStatus = {
  optional: '可選擇',
  selected: '已選擇',
  alreadyInPack: '已在產品包',
};

// 共用的每頁筆數
export const LIST_PAGE_COUNT = 10;

export const BonusSaleTypes = {
  1: '餐廳',
  2: '網路訂單',
  3: '生日禮',
  4: '入會禮',
  5: '推薦禮',
  6: 'Email綁定',
  7: '兌換紅利商品',
  8: '去年度紅利點數歸零',
  9: '推薦碼兌換',
  10: '活動禮',
  11: '公關券',
};

export const BonusStatus = {
  NORMAL: 0,
  MAKEUP: 1,
  DELETE: 99,
};

export const BonusStatusText = {
  [BonusStatus.NORMAL]: '正常',
  [BonusStatus.MAKEUP]: '補登',
  [BonusStatus.DELETE]: '刪除',
};

export const BonusAuditStatus = {
  NULL: 0,
  PENDING: 1,
  NORMAL: 2,
  ERROR: 3,
  SOLVED: 4,
};

export const BonusAuditStatusText = {
  [BonusAuditStatus.NULL]: '尚未稽核',
  [BonusAuditStatus.PENDING]: '尚未稽核',
  [BonusAuditStatus.NORMAL]: '稽核正確',
  [BonusAuditStatus.ERROR]: '稽核異常',
  [BonusAuditStatus.SOLVED]: '已處理',
};

export const MemberLevelText = {
  1: '同窗',
  2: '解惑',
  3: '授業',
  4: '傳道',
  5: '良師',
};

export const SignUpFromText = {
  CP: '竹北',
  line: 'Line',
  onlineclassroomdaily: '線上教室',
  GDKoala: '金考拉',
};

export const BonusProductStatus = {
  OFF_SALE: 0,
  ON_SALE: 1,
  DELETE: 2,
};

export const BonusProductStatusText = {
  [BonusProductStatus.OFF_SALE]: '下線',
  [BonusProductStatus.ON_SALE]: '上線',
  [BonusProductStatus.DELETE]: '刪除',
};

export const BonusProductType = {
  EXCHANGE: 1,
  DISCOUNT: 2,
};

export const BonusProductTypeText = {
  [BonusProductType.EXCHANGE]: '兌換券',
  [BonusProductType.DISCOUNT]: '優惠券',
};

export const BonusProductExpriyDay = {
  ONE_DAY: 1,
  SEVEN_DAYS: 7,
  FOURTEEN_DAYS: 14,
  THIRTY_DAYS: 30,
  SIXTY_DAYS: 60,
  NINETY_DAYS: 90,
};

export const BonusProductExpriyDayText = {
  [BonusProductExpriyDay.ONE_DAY]: '1 天',
  [BonusProductExpriyDay.SEVEN_DAYS]: '7 天',
  [BonusProductExpriyDay.FOURTEEN_DAYS]: '14 天',
  [BonusProductExpriyDay.THIRTY_DAYS]: '30 天',
  [BonusProductExpriyDay.SIXTY_DAYS]: '60 天',
  [BonusProductExpriyDay.NINETY_DAYS]: '90 天',
};

export const PromoCompatibility = {
  NOT_COMPATIBLE: 0,
  ALL_COMPATIBLE: 1,
  PARTIAL_COMPATIBLE: 2,
};

export const PromoCompatibilityText = {
  [PromoCompatibility.NOT_COMPATIBLE]: '不得與其他優惠共用',
  [PromoCompatibility.ALL_COMPATIBLE]: '可與所有優惠併用',
  [PromoCompatibility.PARTIAL_COMPATIBLE]: '可與部分優惠併用',
};

export const UserBonusProductStatus = {
  UN_USE: 0,
  USED: 1,
  GIFTED: 2,
  CANCEL: 3,
  EXPIRED: 99, // 非實際資料庫使用, 與後端協議 99 = 過期
};

export const UserBonusProductStatusText = {
  [UserBonusProductStatus.UN_USE]: '未使用',
  [UserBonusProductStatus.USED]: '已使用',
  [UserBonusProductStatus.GIFTED]: '已贈送',
  [UserBonusProductStatus.EXPIRED]: '過期',
  [UserBonusProductStatus.CANCEL]: '取消',
};

export const UserRoleIds = {
  MEMBER: '1',
  WISDOMBANK_ADMIN: '3',
  SUPER_ADMIN: '8',
  RESTAURANT_STAFF: '19',
  TEACHER_EDUCATION: '22',
};

export const GuestCardStatus = {
  UN_USE: 0,
  USE: 1,
};

export const GuestCardStatusText = {
  [GuestCardStatus.UN_USE]: '未使用',
  [GuestCardStatus.USE]: '使用中',
};

export const ReservationObjectStatus = {
  OFFLINE: 0,
  ONLINE: 1,
};

export const ReservationObjectStatusText = {
  [ReservationObjectStatus.OFFLINE]: '下架',
  [ReservationObjectStatus.ONLINE]: '上架',
};

export const UserProductPackageOrderStatus = {
  USED: 1,
  CANCEL: 3,
};

export const UserProductPackageOrderStatusText = {
  [UserProductPackageOrderStatus.USED]: '使用中',
  [UserProductPackageOrderStatus.CANCEL]: '取消',
};

export const ProductPackageStatus = {
  ALL: -1,
  ONLINE: 1,
  OFFLINE: 0,
};

export const ProductPackageStatusText = {
  [ProductPackageStatus.ALL]: '全部',
  [ProductPackageStatus.ONLINE]: '上線',
  [ProductPackageStatus.OFFLINE]: '下線',
};

export const UserProductPackagePayType = {
  OFFLINE_PAY: 0,
  ONLINE_PAY: 1,
  PAYING_MEMBER: 2,
};

export const UserProductPackagePayTypeText = {
  [UserProductPackagePayType.OFFLINE_PAY]: '現場付款',
  [UserProductPackagePayType.ONLINE_PAY]: '線上付款',
  [UserProductPackagePayType.PAYING_MEMBER]: 'VIP 會員',
};

export const UserMemberPointStatus = {
  NORMAL: 0,
  MAKEUP: 1,
  DELETE: 99,
};

export const UserMemberPointStatusText = {
  [UserMemberPointStatus.NORMAL]: '正常',
  [UserMemberPointStatus.MAKEUP]: '補登',
  [UserMemberPointStatus.DELETE]: '刪除',
};

export const UserMemberPointType = {
  REWARD: 1,
  EXCHANGE: 2,
};

export const UserMemberPointTypeText = {
  [UserMemberPointType.REWARD]: '回饋',
  [UserMemberPointType.EXCHANGE]: '兌換',
};

export const SubscriptionServiceTypeCode = {
  DAILY_SERVICE: 'DailyService',
  EXPLANATION: 'Explanation',
  ALL: 'all',
};

export const SubscriptionServiceTypeCodeText = {
  [SubscriptionServiceTypeCode.DAILY_SERVICE]: '每日服務',
  [SubscriptionServiceTypeCode.EXPLANATION]: '詳解服務',
  [SubscriptionServiceTypeCode.ALL]: '全部服務',
};

export const SubscriptionServiceStatus = {
  ALL: -1,
  ONLINE: 1,
  OFFLINE: 0,
  DELETE: 99,
};

export const SubscriptionServiceStatusText = {
  [SubscriptionServiceStatus.ALL]: '全部',
  [SubscriptionServiceStatus.ONLINE]: '上線',
  [SubscriptionServiceStatus.OFFLINE]: '下線',
  [SubscriptionServiceStatus.DELETE]: '刪除',
};

export const PayingMemberPlanStatus = {
  OFFLINE: 0,
  ONLINE: 1,
};

export const PayingMemberPlanStatusText = {
  [PayingMemberPlanStatus.OFFLINE]: '下架',
  [PayingMemberPlanStatus.ONLINE]: '上架',
};

export const PayingMemberPayType = {
  OFFLINE_PAY: 0,
  ONLINE_PAY: 1,
};

export const PayingMemberPayTypeText = {
  [PayingMemberPayType.OFFLINE_PAY]: '現場付款',
  [PayingMemberPayType.ONLINE_PAY]: '線上付款',
};

export const SubscriptionServicePayType = {
  OFFLINE_PAY: 0,
  ONLINE_PAY: 1,
};

export const SubscriptionServicePayTypeText = {
  [SubscriptionServicePayType.OFFLINE_PAY]: '現場付款',
  [SubscriptionServicePayType.ONLINE_PAY]: '線上付款',
};

export const BonusProductQRCodeStatus = {
  ALL: -1,
  FOR_SALE: 1,
  LINK: 2,
  USE: 3,
};

export const BonusProductQRCodeStatusText = {
  [BonusProductQRCodeStatus.ALL]: '全部',
  [BonusProductQRCodeStatus.FOR_SALE]: '待售',
  [BonusProductQRCodeStatus.LINK]: '已歸戶',
  [BonusProductQRCodeStatus.USE]: '已使用',
};

export const PrefixSerialOptions = ['LSSA', 'LSSB', 'LSSC'];

export const PCFARM_DEPARTMENTS = {
  dept: {
    name: '部門',
    useValue: 'input',
  },
  housekeeping: {
    name: '家政班',
    useValue: 'name',
  },
  evergreen: {
    name: '長青班',
    useValue: 'nameAndSelect',
    options: [
      {
        groupName: '板橋一',
        className: ['江翠', '福德', '國泰'],
      },
      {
        groupName: '板橋二',
        className: ['埔墘', '社後', '潮和'],
      },
      {
        groupName: '公館一',
        className: ['埤墘', '華江', '信義'],
      },
      {
        groupName: '公館二',
        className: ['大觀', '後埔', '崑崙'],
      },
    ],
  },
};

export const USER_PAYING_MEMBER_COUPON_TYPE = {
  UNCLAIMED: '未領券',
  PAPER: '紙本券',
  DIGITAL: '數位券',
};

export const PACKAGE_PRODUCT_MEMBER_TYPE = {
  GENERAL_MEMBER: 0,
  VIP_MEMBER: 1,
};

export const PACKAGE_PRODUCT_MEMBER_TYPE_TEXT = {
  [PACKAGE_PRODUCT_MEMBER_TYPE.GENERAL_MEMBER]: '一般會員',
  [PACKAGE_PRODUCT_MEMBER_TYPE.VIP_MEMBER]: 'VIP 會員',
};

export const MemberTypeList = {
  all: 1,
  carpDragon: 2,
  mod: 3,
  payingMember: 4,
  normalMember: 5,
  restaurantStaff: 6,
};
